import React from "react";

export default function HeroSection() {
	return (
		<section className="flex flex-col font-sans items-center justify-center text-black px-4 pt-24 pb-4">
			<h1 className="text-4xl md:text-5xl font-bold mb-4 text-center">A single Toolkit</h1>
			<h1 className="text-4xl md:text-5xl font-bold text-sky-400 mb-4 text-center">To stop all abuses</h1>
			<p className="lg:text-lg md:text-base mt-6 text-center max-w-2xl">Plug-and-play abuse prevention toolkit for startups & indie devs.</p>
			<p className="lg:text-lg md:text-base text-center max-w-2xl">Block fake signups, promo & affiliation fraud, and card testing in minutes.</p>
			<p className="lg:text-lg md:text-base text-center max-w-2xl">No complex setup or expensive tools.</p>
			<p className="lg:text-lg md:text-base text-center max-w-2xl">No more </p>
			<p className="lg:text-lg md:text-base text-center max-w-2xl">Get a clear overview of your fight against abuse with clear and insightful dashobards.</p>
		</section>
	);
}
